// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2aV5V","inner":"Form_inner__ZFjEU","range":"Form_range__1LFtM","name":"Form_name__3lgSv","actions":"Form_actions__231wa"};